var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9688 10.6665C27.1779 10.6665 28.9688 8.87564 28.9688 6.6665C28.9688 4.45736 27.1779 2.6665 24.9688 2.6665C22.7596 2.6665 20.9688 4.45736 20.9688 6.6665C20.9688 8.87564 22.7596 10.6665 24.9688 10.6665Z",
    stroke: "#367BBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96875 20C11.1779 20 12.9688 18.2091 12.9688 16C12.9688 13.7909 11.1779 12 8.96875 12C6.75961 12 4.96875 13.7909 4.96875 16C4.96875 18.2091 6.75961 20 8.96875 20Z",
    stroke: "#367BBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9688 29.3335C27.1779 29.3335 28.9688 27.5426 28.9688 25.3335C28.9688 23.1244 27.1779 21.3335 24.9688 21.3335C22.7596 21.3335 20.9688 23.1244 20.9688 25.3335C20.9688 27.5426 22.7596 29.3335 24.9688 29.3335Z",
    stroke: "#367BBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4221 18.0132L21.5288 23.3198",
    stroke: "#367BBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5155 8.68018L12.4221 13.9868",
    stroke: "#367BBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.1de6117c4072280a632a5cbe6c5387f6.svg";
export { ForwardRef as ReactComponent };